export default [
  {
    type: 'standard',
    path: '/standard/react-node/client/src/',
    name: 'App.jsx',
    content: `{FALLBACK TEMPLATE CODE}import { PayPalScriptProvider, PayPalButtons, FUNDING } from "@paypal/react-paypal-js";

function App() {
  const FUNDING_SOURCES = [
    {{ fundingSources,short_list_2 }}
  ];
  
  const initialOptions = {
    "client-id": "{{ clientId }}",
    "enable-funding": "paylater,venmo",
  }

  return (
    <div className="App">
        <PayPalScriptProvider options={initialOptions}>
        {
          FUNDING_SOURCES.map(fundingSource=>{
            return(
              <PayPalButtons
                fundingSource={fundingSource}
                key={fundingSource}
                
                style={{
                  layout: '{{ buttonLayout }}',
                  shape: '{{ buttonStyle }}',
                  color: (fundingSource==paypal.FUNDING.PAYLATER) ? 'gold' : '',
                }}

                createOrder={async (data, actions) => {
                  try {
                    const response = await fetch("http://localhost:9597/orders", {
                      method: "POST"
                    });
                
                    const details = await response.json();
                    return details.id;
                  } catch (error) {
                    console.error(error);
                    // Handle the error or display an appropriate error message to the user
                  }
                }}

                {{ createOrderSubscription_react,8 }}
              
                onApprove={async (data, actions) => {
                  try {
                    const response = await fetch(\`http://localhost:9597/orders/\${data.orderID}/capture\`, {
                      method: "POST"
                    });             
                  
                    const details = await response.json();
                    // Three cases to handle:
                    //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
                    //   (2) Other non-recoverable errors -> Show a failure message
                    //   (3) Successful transaction -> Show confirmation or thank you message

                    // This example reads a v2/checkout/orders capture response, propagated from the server
                    // You could use a different API or structure for your 'orderData'
                    const errorDetail = Array.isArray(details.details) && details.details[0];
                  
                    if (errorDetail && errorDetail.issue === 'INSTRUMENT_DECLINED') {
                      return actions.restart();
                      // https://developer.paypal.com/docs/checkout/integration-features/funding-failure/
                    }

                    if (errorDetail) {
                      let msg = 'Sorry, your transaction could not be processed.';
                      msg += errorDetail.description ? ' ' + errorDetail.description : '';
                      msg += details.debug_id ? ' (' + details.debug_id + ')' : '';
                      alert(msg);
                    }
                    
                    // Successful capture! For demo purposes:
                    console.log('Capture result', details, JSON.stringify(details, null, 2));
                    const transaction = details.purchase_units[0].payments.captures[0];
                    alert('Transaction '+ transaction.status + ': ' + transaction.id + 'See console for all available details');
                  } catch (error) {
                    console.error(error);
                    // Handle the error or display an appropriate error message to the user
                  }
                }}
            />)
          })
        }
        </PayPalScriptProvider>
    </div>
  );
}

export default App;
`,
  },
  {
    type: 'standard',
    path: '/standard/html-node/',
    name: 'index.html',
    content: `{FALLBACK TEMPLATE CODE}<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>PayPal JS SDK Demo</title>
  </head>
  <body>
    <script data-sdk-integration-source="integrationbuilder_sc"></script>
    <div id="paypal-button-container"></div>
    <script src="https://www.paypal.com/sdk/js?client-id={{ clientId }}>&components=buttons&enable-funding=venmo,paylater"></script>
    <script>
      const FUNDING_SOURCES = [
        {{ fundingSources,list }}
      ];
      FUNDING_SOURCES.forEach(fundingSource => {
        paypal.Buttons({
          fundingSource,
          
          style: {
            layout: '{{ buttonLayout }}',
            shape: '{{ buttonStyle }}',
            color: (fundingSource==paypal.FUNDING.PAYLATER) ? 'gold' : '',
          },

          createOrder: async (data, actions) => {
            try {
                const response = await fetch("http://localhost:9597/orders", {
                    method: "POST"
                });

                const details = await response.json();
                return details.id;
            } catch (error) {
                console.error(error);
                // Handle the error or display an appropriate error message to the user
            }
          },

          {{ createOrderSubscription,5 }}

          onApprove: async (data, actions) => {
            try {
              const response = await fetch(\`http://localhost:9597/orders/\${data.orderID}/capture\`, {
                  method: "POST"
              });             
                    
              const details = await response.json();
              // Three cases to handle:
              //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
              //   (2) Other non-recoverable errors -> Show a failure message
              //   (3) Successful transaction -> Show confirmation or thank you message

              // This example reads a v2/checkout/orders capture response, propagated from the server
              // You could use a different API or structure for your 'orderData'
              const errorDetail = Array.isArray(details.details) && details.details[0];
                    
              if (errorDetail && errorDetail.issue === 'INSTRUMENT_DECLINED') {
                  return actions.restart();
                  // https://developer.paypal.com/docs/checkout/integration-features/funding-failure/
              }

              if (errorDetail) {
                  let msg = 'Sorry, your transaction could not be processed.';
                  msg += errorDetail.description ? ' ' + errorDetail.description : '';
                  msg += details.debug_id ? ' (' + details.debug_id + ')' : '';
                  alert(msg);
              }
                        
              // Successful capture! For demo purposes:
              console.log('Capture result', details, JSON.stringify(details, null, 2));
              const transaction = details.purchase_units[0].payments.captures[0];
              alert('Transaction '+ transaction.status + ': ' + transaction.id + 'See console for all available details');
          } catch (error) {
              console.error(error);
              // Handle the error or display an appropriate error message to the user
          }
        }, 
      }).render("#paypal-button-container");       
      })
    </script>
  </body>
</html>
      `,
  },
  {
    type: 'standard',
    path: '/standard/angular-node/client/src/app/',
    name: 'app.component.ts',
    content: `{FALLBACK TEMPLATE CODE}import { Component } from "@angular/core";
import { IPayPalConfig } from "ngx-paypal";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
})
export class AppComponent {
  title = "client";
  public payPalConfig?: IPayPalConfig;
  ngOnInit(): void {
    this.initConfig();
  }

  private initConfig(): void {
    this.payPalConfig = {
      fundingSource: [
        {{ fundingSources,list }}
      ],
      style: {
        layout: '{{ buttonLayout }}',
        shape: '{{ buttonStyle }}',
        color: (fundingSource==paypal.FUNDING.PAYLATER) ? 'gold' : '',
      },
      currency: "USD",
      clientId: "{{ clientId }}",

      createOrderOnServer: async (data) => {
        const response = await fetch("http://localhost:9597/orders/", {
          method: "POST",
        });
        const details = await response.json();
        return details.id;
      },
      {{ createOrderSubscription_angular,3 }}
      authorizeOnServer: async (approveData, actions) => {
        const response = await fetch(
          \`http://localhost:9597/orders/\${approveData.orderID}/capture\`,
          {
            method: "POST",
          }
        );
        const details = await response.json();
        // Three cases to handle:
        //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
        //   (2) Other non-recoverable errors -> Show a failure message
        //   (3) Successful transaction -> Show confirmation or thank you

        // This example reads a v2/checkout/orders capture response, propagated from the server
        // You could use a different API or structure for your 'orderData'

        const errorDetail = Array.isArray(details.details) && details.details[0];
        if (errorDetail && errorDetail.issue === 'INSTRUMENT_DECLINED') {
          return actions.restart(); // Recoverable state, per:
          // https://developer.paypal.com/docs/checkout/integration-features/funding-failure/
        }

        if (errorDetail) {
          let msg = 'Sorry, your transaction could not be processed.';
          if (errorDetail.description) msg += '' + errorDetail.description;
          if (details.debug_id) msg += ' (' + details.debug_id + ')';
          return alert(msg); // Show a failure message (try to avoid alerts in production environments)
        }

        // Successful capture! For demo purposes:
        console.log('Capture result', details, JSON.stringify(details, null, 2));
        const transaction = details.purchase_units[0].payments.captures[0];
        alert('Transaction '+ transaction.status + ': ' + transaction.id + 'See console for all available details');
      },

      onCancel: (data, actions) => {
        console.log("OnCancel", data, actions);
      },
      onError: (err) => {
        console.log("OnError", err);
      },
      onClick: (data, actions) => {
        console.log("onClick", data, actions);
      },
    };
  }
}
      `,
  },
  {
    type: 'standard',
    path: '/standard/html-node/',
    name: 'index.js',
    content: `{FALLBACK TEMPLATE CODE}
import express from "express";
import fetch from "node-fetch";
import cors from "cors";
import "dotenv/config";

const { CLIENT_ID, APP_SECRET } = process.env;
const app = express();
const base = "https://api-m.sandbox.paypal.com";
const app = express();
app.use(cors({origin: '*'}));

const generateAccessToken = async () => {
  try {
      const auth = Buffer.from(CLIENT_ID + ":" + APP_SECRET).toString("base64");
      const response = await fetch(\`\${base}/v1/oauth2/token\`, {
        method: "post",
        body: "grant_type=client_credentials",
        headers: {
          Authorization: \`Basic \${auth}\`,
        },
      });
    
      const data = await response.json();
      return data.access_token;
  } catch(error) {
      console.error("Failed to generate Access Token:", error);
  } 
};

const createOrder = async () => {
  const accessToken = await generateAccessToken();
  const url = \`\${base}/v2/checkout/orders\`;
  const payload = {
      intent: "CAPTURE",
      purchase_units: [
      {
          amount: {
          currency_code: "USD",
          value: "0.02",
          },
      },
      ],
  };

  const response = await fetch(url, {
      headers: {
          "Content-Type": "application/json",
          Authorization: \`Bearer \${accessToken}\`,
      },
      method: "POST",
      body: JSON.stringify(payload),
  });

  return handleResponse(response);
};


const capturePayment = async (orderID) => {
  const accessToken = await generateAccessToken();
  const url = \`\${base}/v2/checkout/orders/\${orderID}/capture\`;

  const response = await fetch(url, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: \`Bearer \${accessToken}\`,
      }
  });
  
  return handleResponse(response);
};

async function handleResponse(response) {
  if (response.status === 200 || response.status === 201) {
    return response.json();
  }

  const errorMessage = await response.text();
  throw new Error(errorMessage);
}


app.post("/orders", async (req, res) => {
  try{
      const response = await createOrder();
      res.json(response);
  } catch(error) {
      console.error("Failed to create order:", error);
      res.status(500).json({ error: "Failed to create order." });
  }
});

app.post("/orders/:orderID/capture", async (req, res) => {
  try {
      const { orderID } = req.params;
      const response = await capturePayment(orderID);
      res.json(response);
  } catch (error){
      console.error("Failed to create order:", error);
      res.status(500).json({ error: "Failed to capture order." });
  }
});

app.listen(9597, () => {
  console.log("listening on http://localhost:9597/");
});
`,
  },

  {
    type: 'advanced',
    path: '/advance/3ds-node/public/',
    name: 'app.js',
    content: `{FALLBACK TEMPLATE CODE}
  const FUNDING_SOURCES = [
    {{ fundingSources, list_2 }}
  ];
  
  function handleTransactionCases(details) {
    // Three cases to handle:
    //    (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
    //    (2) Other non-recoverable errors -> Show a failure message
    //    (3) Successful transaction -> Show confirmation or thank you message
  
    // This example reads a v2/checkout/orders capture response, propagated from the server
    // You could use a different API or structure for your 'orderData'
    const errorDetail = Array.isArray(details.details) && details.details[0];
  
    if (errorDetail && errorDetail.issue === "INSTRUMENT_DECLINED") {
      return actions.restart();
      // https://developer.paypal.com/docs/checkout/integration-features/funding-failure/
    }
  
    if (errorDetail) {
      let msg = "Sorry, your transaction could not be processed.";
      msg += errorDetail.description ? " " + errorDetail.description : "";
      msg += details.debug_id ? " (" + details.debug_id + ")" : "";
      alert(msg);
    }
  
    const transaction = details.purchase_units[0].payments.captures[0];
    alert("Transaction " + transaction.status + ": " + transaction.id + ". See console for all available details");
  }
  
  async function onCreateOrder(data, actions) {
    try {
      const response = await fetch("/api/orders", {
        method: "POST",
      });
  
      const details = await response.json();
      return details.id;
    } catch (error) {
      console.error(error);
    }
  }
  
  async function onCaptureOrder(data, actions, orderID) {
    const threedsElement = document.getElementById("threeds");
    threedsElement.innerHTML = "";
    const orderId = data ? data.orderID : orderID;
    
    try {
      const response = await fetch(\`/api/orders/\${orderId}/capture\`, {
        method: "POST",
      });
  
      const details = await response.json();
      handleTransactionCases(details);
    } catch (error) {
      console.error(error);
    }
  }
  
  //Close 3Ds Dialog
  function onClose() {
    const threedsElement = document.getElementById("threeds");
    threedsElement.innerHTML = "";
  }
  
  //Handle 3Ds Payload
  async function onHandle3Ds(payload, orderId) {
    const { liabilityShifted, liabilityShift } = payload;
  
    if (liabilityShift === "POSSIBLE") {
      await onCaptureOrder(null, null, orderId);
    } else if (liabilityShifted === false || liabilityShifted === undefined) {
      document.getElementById("threeds").innerHTML = \`<Dialog open>
          <p>You have the option to complete the payment at your own risk,
            meaning that the liability of any chargeback has not shifted from
            the merchant to the card issuer.</p>
          <button onclick=onCaptureOrder(\${null},\${null},"\${orderId}")>Pay Now</button>
          <button onclick=onClose()>Close</button>
        </Dialog>
      \`;
    }
  }
  
  FUNDING_SOURCES.forEach((fundingSource) => {
    paypal.Buttons({
        fundingSource,
        style: {
          layout: "vertical",
          shape: "{{ buttonStyle }}",
          color: (fundingSource==paypal.FUNDING.PAYLATER) ? 'gold' : '',
        },
        createOrder: async (data, actions) => onCreateOrder(data, actions),
        onApprove: async (data, actions) => onCaptureOrder (data, actions, null),
      })
      .render("#paypal-button-container");
  });
  
  // If this returns false or the card fields aren't visible, see Step #1.
  if (paypal.HostedFields.isEligible()) {
    let orderId;
  
    // Renders card fields
    paypal.HostedFields.render({
      // Call your server to set up the transaction
      createOrder: async (data, actions) => {
        orderId = await onCreateOrder(data, actions);
        return orderId;
      },
      styles: {
        ".valid": {
          color: "green",
        },
        ".invalid": {
          color: "red",
        },
      },
      fields: {
        number: {
          selector: "#card-number",
          placeholder: "4111 1111 1111 1111",
        },
        cvv: {
          selector: "#cvv",
          placeholder: "123",
        },
        expirationDate: {
          selector: "#expiration-date",
          placeholder: "MM/YY",
        },
      },
    }).then((cardFields) => {
      document.querySelector("#card-form").addEventListener("submit", async (event) => {
          event.preventDefault();
          try {
            const { value: cardHolderName } = document.getElementById("card-holder-name");
            const { value: postalCode } = document.getElementById("card-billing-address-zip");
            const { value: countryCodeAlpha2 } = document.getElementById("card-billing-address-country");
  
            const payload = await cardFields.submit({
              cardHolderName,
              contingencies: ["SCA_ALWAYS"],
              billingAddress: {
                postalCode,
                countryCodeAlpha2,
              },
            });
  
            await onHandle3Ds(payload, orderId);
          } catch (error) {
            alert("Payment could not be captured! " + JSON.stringify(error));
          }
        });
    });
  } else {
    // Hides card fields if the merchant isn't eligible
    document.querySelector("#card-form").style = "display: none";
  }
`,
  },
  {
    type: 'advanced',
    path: '/advance/3ds-node/public/',
    name: 'server.js',
    content: `{FALLBACK TEMPLATE CODE}
import "dotenv/config";
import express from "express";
import * as paypal from "./paypal-api.js";

const app = express();
app.set("view engine", "ejs");
app.use(express.static("public"));

// render checkout page with client id & unique client token
app.get("/", async (req, res) => {
  const clientId = process.env.CLIENT_ID;
  try {
    const clientToken = await paypal.generateClientToken();
    res.render("checkout", { clientId, clientToken });
  } catch (err) {
    res.status(500).send(err.message);
  }
});

// create order
app.post("/api/orders", async (req, res) => {
  try {
    const order = await paypal.createOrder();
    res.json(order);
  } catch (err) {
    res.status(500).send(err.message);
  }
});

// capture payment
app.post("/api/orders/:orderID/capture", async (req, res) => {
  const { orderID } = req.params;
  try {
    const captureData = await paypal.capturePayment(orderID);
    res.json(captureData);
  } catch (err) {
    res.status(500).send(err.message);
  }
});

app.listen(9597, () => {
  console.log("listening on http://localhost:9597/");
});
`,
  },
  {
    type: 'advanced',
    path: '/advance/3ds-node/public/',
    name: 'index.html',
    content: `{FALLBACK TEMPLATE CODE}
  <html>
    <head>
      <meta charset="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link
        rel="stylesheet"
        type="text/css"
        href="https://www.paypalobjects.com/webstatic/en_US/developer/docs/css/cardfields.css"
      />
    
      <script type="text/javascript">
        const script = document.createElement("script");
        script.setAttribute(
          "data-sdk-integration-source",
          "integrationbuilder_ac"
        );
        const client_id = '{{ clientId }}';
        async function getToken() {
          let token;
          await fetch("/api/token", {
            method: "post",
          }).then((res)=>res.json())
          .then((clientToken) => {
            token = clientToken;
        });
        console.log(token);
        return token;
      };
    
      async function getApp(){
        script = document.createElement('script');
        script.src = './app.js';
        document.body.appendChild(script);
      };
      
      async function test() {
        const client_token = await getToken();
        const script = document.createElement('script');
        script.src = 'https://www.paypal.com/sdk/js?client-id='+client_id+'&locale=en_US&vault=false&enable-funding=venmo&currency=USD&buyer-country=US&components=buttons,hosted-fields';
        script.setAttribute('data-client-token', client_token);
        document.head.appendChild(script);
        script.onload = function() {
          getApp();
        }
      };
      test();
    </script>
    </head>
    <body>
    <div id="paypal-button-container" class="paypal-button-container"></div>
    <div>
      <p style = "text-align: center;">OR </p>
    </div>
    <div class="card_container">
      <form id="card-form">
        <div id="card-number" class="card_field"></div>
        <div style="display: flex; flex-direction: row;">
          <div>
            <div id="expiration-date" class="card_field" ></div>
          </div>
          <div style="margin-left: 10px;">
            <div id="cvv" class="card_field" style="margin-left: 50px"></div>
          </div>
        </div>
        <div>
          <input
            type="text"
            id="card-holder-name"
            name="card-holder-name"
            autocomplete="off"
            placeholder="Name on Card"
            class="card-field"
            style=" font-family:helvetica; font-size:14px;"
          />
          <div>
            <input
              type="text"
              id="card-billing-address-country"
              name="card-billing-address-country"
              autocomplete="off"
              placeholder="Country Code"
              style=" font-family:helvetica; font-size:14px;"
            />
          </div>
        </div>
        <br /><br />
        <button value="submit" id="submit" class="btn" style="width:760px; height:50px; background:#009c74; color:white">PAY</button>
      </form>
    </div>
    <div id="threeds"></div>
    <!--<script src="./app.js"></script> -->
  </body>
</html>`,
  },
  {
    type: 'advanced',
    path: '/advance/html-node/public/',
    name: 'app.js',
    content: `{FALLBACK TEMPLATE CODE}
  const FUNDING_SOURCES = [
    {{ fundingSources, list_2 }}
  ];
  
  function handleTransactionCases(details) {
    // Three cases to handle:
    //    (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
    //    (2) Other non-recoverable errors -> Show a failure message
    //    (3) Successful transaction -> Show confirmation or thank you message
  
    // This example reads a v2/checkout/orders capture response, propagated from the server
    // You could use a different API or structure for your 'orderData'
    const errorDetail = Array.isArray(details.details) && details.details[0];
  
    if (errorDetail && errorDetail.issue === "INSTRUMENT_DECLINED") {
      return actions.restart();
      // https://developer.paypal.com/docs/checkout/integration-features/funding-failure/
    }
  
    if (errorDetail) {
      let msg = "Sorry, your transaction could not be processed.";
      msg += errorDetail.description ? " " + errorDetail.description : "";
      msg += details.debug_id ? " (" + details.debug_id + ")" : "";
      alert(msg);
    }
  
    const transaction = details.purchase_units[0].payments.captures[0];
    alert("Transaction " + transaction.status + ": " + transaction.id + ". See console for all available details");
  }
  
  async function onCreateOrder(data, actions) {
    try {
      const response = await fetch("/api/orders", {
        method: "POST",
      });
  
      const details = await response.json();
      return details.id;
    } catch (error) {
      console.error(error);
    }
  }
  
  async function onCaptureOrder(data, actions, orderID) {
    const orderId = data ? data.orderID : orderID;
    
    try {
      const response = await fetch(\`/api/orders/\${orderId}/capture\`, {
        method: "POST",
      });
  
      const details = await response.json();
      handleTransactionCases(details);
    } catch (error) {
      console.error(error);
    }
  }
  
  
  FUNDING_SOURCES.forEach((fundingSource) => {
    paypal.Buttons({
        fundingSource,
        style: {
          layout: "vertical",
          shape: "{{ buttonStyle }}",
          color: fundingSource === paypal.FUNDING.PAYLATER ? "gold" : "",
        },
        createOrder: async (data, actions) => onCreateOrder(data, actions),
        onApprove: async (data, actions) => onCaptureOrder (data, actions, null),
      })
      .render("#paypal-button-container");
  });
  
  // If this returns false or the card fields aren't visible, see Step #1.
  if (paypal.HostedFields.isEligible()) {
    let orderId;
  
    // Renders card fields
    paypal.HostedFields.render({
      // Call your server to set up the transaction
      createOrder: async (data, actions) => {
        orderId = await onCreateOrder(data, actions);
        return orderId;
      },
      styles: {
        ".valid": {
          color: "green",
        },
        ".invalid": {
          color: "red",
        },
      },
      fields: {
        number: {
          selector: "#card-number",
          placeholder: "4111 1111 1111 1111",
        },
        cvv: {
          selector: "#cvv",
          placeholder: "123",
        },
        expirationDate: {
          selector: "#expiration-date",
          placeholder: "MM/YY",
        },
      },
    }).then((cardFields) => {
      document.querySelector("#card-form").addEventListener("submit", async (event) => {
          event.preventDefault();
          try {
            const { value: cardHolderName } = document.getElementById("card-holder-name");
            const { value: postalCode } = document.getElementById("card-billing-address-zip");
            const { value: countryCodeAlpha2 } = document.getElementById("card-billing-address-country");
  
            await cardFields.submit({
              cardHolderName,
              billingAddress: {
                postalCode,
                countryCodeAlpha2,
              },
            });
  
            await onCaptureOrder (null, null, orderId);
          } catch (error) {
            alert("Payment could not be captured! " + JSON.stringify(error));
          }
        });
    });
  } else {
    // Hides card fields if the merchant isn't eligible
    document.querySelector("#card-form").style = "display: none";
  }
`,
  },
  {
    type: 'advanced',
    path: '/advance/html-node/',
    name: 'paypal-api.js',
    content: `{FALLBACK TEMPLATE CODE}
import fetch from "node-fetch";

// set some important variables
const { CLIENT_ID, APP_SECRET } = process.env;
const base = "https://api-m.sandbox.paypal.com";

// call the create order method
export async function createOrder() {
  const purchaseAmount = "100.00"; // TODO: pull prices from a database
  const accessToken = await generateAccessToken();
  const url = \`\${base}/v2/checkout/orders\`;
  const response = await fetch(url, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: \`Bearer \${accessToken}\`,
    },
    body: JSON.stringify({
      intent: "CAPTURE",
      purchase_units: [
        {
          amount: {
            currency_code: "USD",
            value: purchaseAmount,
          },
        },
      ],
    }),
  });

  return handleResponse(response);
}

// capture payment for an order
export async function capturePayment(orderId) {
  const accessToken = await generateAccessToken();
  const url = \`\${base}/v2/checkout/orders/\${orderId}/capture\`;
  const response = await fetch(url, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: \`Bearer \${accessToken}\`,
    },
  });

  return handleResponse(response);
}

// generate access token
export async function generateAccessToken() {
  const auth = Buffer.from(CLIENT_ID + ":" + APP_SECRET).toString("base64");
  const response = await fetch(\`\${base}/v1/oauth2/token\`, {
    method: "post",
    body: "grant_type=client_credentials",
    headers: {
      Authorization: \`Basic \${auth}\`,
    },
  });
  const jsonData = await handleResponse(response);
  return jsonData.access_token;
}

// generate client token
export async function generateClientToken() {
  const accessToken = await generateAccessToken();
  const response = await fetch(\`\${base}/v1/identity/generate-token\`, {
    method: "post",
    headers: {
      Authorization: \`Bearer \${accessToken}\`,
      "Accept-Language": "en_US",
      "Content-Type": "application/json",
    },
  });
  console.log('response', response.status)
  const jsonData = await handleResponse(response);
  return jsonData.client_token;
}

async function handleResponse(response) {
  if (response.status === 200 || response.status === 201) {
    return response.json();
  }

  const errorMessage = await response.text();
  throw new Error(errorMessage);
}
`,
  },
  {
    type: 'advanced',
    path: '/advance/html-node/public/',
    name: 'checkout.ejs',
    content: `{FALLBACK TEMPLATE CODE}
<html>
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <link
    rel="stylesheet"
    type="text/css"
    href="https://www.paypalobjects.com/webstatic/en_US/developer/docs/css/cardfields.css"
  />
  <script
    src="https://www.paypal.com/sdk/js?components=buttons,hosted-fields&client-id={{ clientId }}&enable-funding={{ fundingSources, inline_list }}"
    data-client-token="<%= clientToken %>"
  ></script>
</head>
<body>
  <div id="paypal-button-container" class="paypal-button-container"></div>
  <div class="card_container">
    <form id="card-form">
      <label for="card-number">Card Number</label>
      <div id="card-number" class="card_field"></div>
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        "
      >
        <div>
          <label for="expiration-date">Expiration Date</label>
          <div id="expiration-date" class="card_field"></div>
        </div>
        <div>
          <label for="cvv">CVV</label>
          <div id="cvv" class="card_field"></div>
        </div>
      </div>
      <label for="card-holder-name">Name on Card</label>
      <input
        type="text"
        id="card-holder-name"
        name="card-holder-name"
        autocomplete="off"
        placeholder="card holder name"
      />
      <div>
        <input
          type="text"
          id="card-billing-address-zip"
          name="card-billing-address-zip"
          autocomplete="off"
          placeholder="zip / postal code"
        />
      </div>
      <div>
        <input
          type="text"
          id="card-billing-address-country"
          name="card-billing-address-country"
          autocomplete="off"
          placeholder="country code"
        />
      </div>
      <br /><br />
      <button value="submit" id="submit" class="btn">Pay</button>
    </form>
  </div>
  <script src="app.js"></script>
</body>
</html>`,
  },
  {
    type: 'advanced',
    path: '/advance/3ds-node/public/',
    name: 'checkout.ejs',
    content: `{FALLBACK TEMPLATE CODE} 
<html>
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <link
      rel="stylesheet"
      type="text/css"
      href="https://www.paypalobjects.com/webstatic/en_US/developer/docs/css/cardfields.css"
    />
    <script
      src="https://www.paypal.com/sdk/js?components=buttons,hosted-fields&client-id={{ clientId }}&enable-funding={{ fundingSources, inline_list }}"
      data-client-token="<%= clientToken %>"
    ></script>
  </head>
  <body>
    <div id="paypal-button-container" class="paypal-button-container"></div>
    <div class="card_container">
      <form id="card-form">
        <label for="card-number">Card Number</label>
        <div id="card-number" class="card_field"></div>
        <div
          style="
            display: flex;
            flex-direction: row;
            justify-content: space-between;
          "
        >
          <div>
            <label for="expiration-date">Expiration Date</label>
            <div id="expiration-date" class="card_field"></div>
          </div>
          <div>
            <label for="cvv">CVV</label>
            <div id="cvv" class="card_field"></div>
          </div>
        </div>
        <label for="card-holder-name">Name on Card</label>
        <input
          type="text"
          id="card-holder-name"
          name="card-holder-name"
          autocomplete="off"
          placeholder="card holder name"
        />
        <div>
          <input
            type="text"
            id="card-billing-address-zip"
            name="card-billing-address-zip"
            autocomplete="off"
            placeholder="zip / postal code"
          />
        </div>
        <div>
          <input
            type="text"
            id="card-billing-address-country"
            name="card-billing-address-country"
            autocomplete="off"
            placeholder="country code"
          />
        </div>
        <br /><br />
        <button value="submit" id="submit" class="btn">Pay</button>
      </form>
    </div>
    <div id="threeds"></div>
    <script src="app.js"></script>
  </body>
</html>
`,
  },
  {
    type: 'advanced',
    path: '/advance/html-node/public/',
    name: 'index.html',
    content: `{FALLBACK TEMPLATE CODE}
<html>
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <link
      rel="stylesheet"
      type="text/css"
      href="https://www.paypalobjects.com/webstatic/en_US/developer/docs/css/cardfields.css"
    />
    <style> .paypal-buttons { margin-bottom:8px; } </style>

    <script type="text/javascript">
      const script = document.createElement("script");
      script.setAttribute(
        "data-sdk-integration-source",
        "integrationbuilder_ac"
      );
      const client_id = '{{ clientId }}';
    
      async function getToken() {
        let token;
        await fetch("/api/token", {
          method: "post",
        }).then((res)=>res.json())
        .then((clientToken) => {
          token = clientToken;
        });
        return token;
      };

      async function getApp(){
        script = document.createElement('script');
        script.src = './app.js';
        document.body.appendChild(script);
      };
  
      async function test() {
        const client_token = await getToken();
        const script = document.createElement('script');
        script.src = 'https://www.paypal.com/sdk/js?client-id='+client_id+'&locale=en_US&vault=false&enable-funding=venmo&currency=USD&buyer-country=US&components=buttons,hosted-fields';
        script.setAttribute('data-client-token', client_token);
        document.head.appendChild(script);
        script.onload = function() {
          getApp();
        }
      };
      test();
    </script>
  </head>
  <body>
    <div id="paypal-button-container" class="paypal-button-container"></div>
      <div>
        <p style = "text-align: center;">OR </p>
      </div>
      
      <div class="card_container">
        <form id="card-form">
          <div id="card-number" class="card_field"></div>
          <div style="display: flex; flex-direction: row;">
            <div>
              <div id="expiration-date" class="card_field" ></div>
            </div>
            <div style="margin-left: 10px;">
              <div id="cvv" class="card_field" style="margin-left: 50px"></div>
            </div>
          </div>
          <div>
            <input
              type="text"
              id="card-holder-name"
              name="card-holder-name"
              autocomplete="off"
              placeholder="Name on Card"
              class="card-field"
              style=" font-family:helvetica; font-size:14px;"
            />
          <div>
          <input
            type="text"
            id="card-billing-address-country"
            name="card-billing-address-country"
            autocomplete="off"
            placeholder="Country Code"
            style=" font-family:helvetica; font-size:14px;"
          />
          <br /><br />
          <button value="submit" id="submit" class="btn" style="width:760px; height:50px; background:#009c74; color:white">PAY</button>
        </form>
      </div>
    <div id="payments-sdk__contingency-lightbox"></div>
  </body>
</html>`,
  },
  {
    type: 'advanced',
    path: '/advance/angular-node/angular/src/app/',
    name: 'app.component.html',
    content: `{FALLBACK TEMPLATE CODE}
<div id="paypal-button-container" class="paypal-button-container" align="center"></div> 
<div>
  <p style = "text-align: center;">OR </p>
</div>
<div class="card_container">
  <form id="card-form" #cardForm="ngForm" (ngSubmit)="onSubmitForm(cardForm.value)">
    <div id="card-number" class="card_field" ></div>
    <div style="display: flex; flex-direction: row;">
      <div>
        <div id="expiration-date" class="card_field" ></div>
      </div>
      <div style="margin-left: 10px;">
        <div id="cvv" class="card_field" style="margin-left: 50px"></div>
      </div>
    </div>
    <div>
      <input
        type="text"
        id="card-holder-name"
        name="card-holder-name"
        autocomplete="off"
        placeholder="Name on Card"
        class="card-field"
        style=" font-family:helvetica; font-size:14px; width:760px;"
        [(ngModel)]="name"
      />
      <div>
        <input
          type="text"
          id="card-billing-address-country"
          name="card-billing-address-country"
          autocomplete="off"
          placeholder="Country Code"
          style="font-family:helvetica; font-size:14px; width:760px; margin-top:10px"
          [(ngModel)]="country"
        />
      </div>
    </div>
    <br /><br />
    <button value="submit" id="submit" class="btn" style="width:760px; height:50px; background:#009c74; color:white">PAY</button>
  </form>
</div>
<div id="payments-sdk__contingency-lightbox"></div>`,
  },
  {
    type: 'advanced',
    path: '/advance/angular-node/angular/src/app/',
    name: 'app.component.ts',
    content: `{FALLBACK TEMPLATE CODE}
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, NgForm } from '@angular/forms';
import {
  IPayPalConfig,
  ICreateOrderRequest,
  PaypalLandingPage
} from 'ngx-paypal';

declare var paypal:any;
// hostedFieldsInstance: paypal.hostedFields;
    
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Tour of Heroes';
  cardForm: any;
  cardFields: any;
  hostedForm: any;
  orderID: any;
  name: 'Name';
  country: 'Country Code';
    
  ngOnInit():void {
    hostedFieldsInstance: paypal.hostedFields;
    paypal.Buttons({
      fundingSource: [
        {{ fundingSources,list }}
      ],
      // Sets up the transaction when a payment button is clicked
      style: {
        layout: {{ buttonLayout }},
        shape: {{ buttonStyle }},
        color: (fundingSource==paypal.FUNDING.PAYLATER) ? 'gold' : '',
      }
      createOrder: function (data:any, actions:any) {
        return fetch("/api/orders", {
          method: "post",
          // use the "body" param to optionally pass additional order information
          // like product ids or amount
        })
          .then((response) => response.json())
          .then((order) => order.id);
      },
      // Finalize the transaction after payer approval
      onApprove: function (data:any, actions:any) {
        return fetch(\`/api/orders/\${data.orderID}/capture\`, {
          method: "post",
        })
          .then((response) => response.json())
          .then((orderData) => {
            console.log(
              "Capture result",
              orderData,
              JSON.stringify(orderData, null, 2)
            );
            const transaction = orderData.purchase_units[0].payments.captures[0];
            alert(\`Transaction \${transaction.status}: \${transaction.id} See console for all available details
            \`);
          });
      },
    })
    .render("#paypal-button-container");
    //     });
    
    if (paypal.HostedFields.isEligible()) {
      let orderId: any;
      // Renders card fields
      paypal.HostedFields.render({
        // Call your server to set up the transaction
        createOrder: () => {
          return fetch("/api/orders", {
            method: "post",
            // use the "body" param to optionally pass additional order information like
            // product ids or amount.
          })
            .then((res) => res.json())
            .then((orderData) => {
              orderId = orderData.id; // needed later to complete capture
              this.orderID = orderData.id;
              return orderData.id;
            });
        },
        styles: {
          ".valid": {
            color: "green",
          },
          ".invalid": {
            color: "red",
          },
        },
        fields: {
          number: {
            selector: "#card-number",
            name: "number",
            placeholder: "Card Number",
            formControlName: "hostedcardNumber",
            ngModel:"4111 1111 1111 1111"
          },
          cvv: {
            selector: "#cvv",
            name: "cvv",
            placeholder: "CVV",
            formControlName: "cvv",
            ngModel:""
          },
          expirationDate: {
            selector: "#expiration-date",
            placeholder: "Expiration Date",
            formControlName: "expiration",
            ngModel:""
          },
        },
      }).then((hostedFieldsInstance:any) => {
        this.hostedForm = hostedFieldsInstance;
        console.log(this.hostedForm);
      });
    }
  }
    
  onSubmitForm(data:any){
    this.hostedForm.submit({
      // Cardholder's first and last name
      cardholderName: this.name,
      // Billing Address
      billingAddress: {
        countryCodeAlpha2: this.country,
      },
    }).then(() => {
      fetch(\`/api/orders/\${this.orderID}/capture\`, {
        method: "post",
      })
        .then((res) => res.json())
        .then((orderData) => {
          const errorDetail =
            Array.isArray(orderData.details) && orderData.details[0];
          if (errorDetail) {
            var msg = "Sorry, your transaction could not be processed.";
            if (errorDetail.description)
              msg += "\\n\\n" + errorDetail.description;
            if (orderData.debug_id) msg += " (" + orderData.debug_id + ")";
            return alert(msg); // Show a failure message
          }
          // Show a success message or redirect
          alert("Transaction completed! Transaction ID - "+orderData.id);
        });
      })
    .catch((err:any) => {
      var msg = err.details[0].description;
      alert("Payment could not be captured! \\n Error - "+msg+" \\n Debug ID - "+err.debug_id);
    });
  }
}`,
  },
  {
    type: 'advanced',
    path: '/advance/angular-node/angular/src/app/',
    name: 'app.module.ts',
    content: `{FALLBACK TEMPLATE CODE}
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPayPalModule } from 'ngx-paypal';
    
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPayPalModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}`,
  },
  {
    type: 'advanced',
    path: '/advance/angular-node/angular/src/',
    name: 'index.html',
    content: `{FALLBACK TEMPLATE CODE}
<!doctype html>
<html lang="en">
  <head>
    <meta charset="utf-8">
    <title>Angular Sample</title>
    <base href="/">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <link
      rel="stylesheet"
      type="text/css"
      href="https://www.paypalobjects.com/webstatic/en_US/developer/docs/css/cardfields.css"
    />
  </head>
  <body>
    <script data-sdk-integration-source="integrationbuilder_ac"></script>
    <app-root></app-root>
  </body>
</html>`,
  },
  {
    type: 'advanced',
    path: '/advance/angular-node/angular/src/',
    name: 'main.ts',
    content: `{FALLBACK TEMPLATE CODE}
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { async } from 'rxjs';
import { __values } from 'tslib';
import { AppModule } from './app/app.module';

const script = document.createElement('script');
const client_id = '{{ clientId }}';
let token = fetch('/api/token', {
  method: "post",
}).then((res) => res.json())
.then((tokenData) => {
  const token = tokenData.client_token;
  script.src = "https://www.paypal.com/sdk/js?client-id="+client_id+"&locale=en_US&vault=false&enable-funding=venmo&currency=USD&buyer-country=US&components=buttons,hosted-fields";
  script.setAttribute('data-client-token',token);
  document.head.appendChild(script);
});
console.log(token);

script.onload = function() {
  platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
}
`,
  },
  {
    type: 'advanced',
    path: '/advance/react-node/advanced-integration/src/',
    name: 'App.js',
    content: `{FALLBACK TEMPLATE CODE}
import { PaymentForm } from "./components/PaymentForm";
import "bootstrap/dist/css/bootstrap.css";
import { useState, useEffect } from "react";
    
const App = (props) => {
  const [clientToken, setClientToken] = useState(null);
  //Replace Client ID and App Secret
  const clientId = "{{ clientId }}";
  useEffect(() => {
    (async () => {
      const response = await fetch("/api/token", {
        method: "post",
      });
      const client_token = await response.json();
      setClientToken(client_token);
    })();
  }, []);
  return (
    <>
      <div className="App">
      <header className="App-header">
      {clientToken ? (
        <PaymentForm clientToken={clientToken} clientID={clientId} />
      ) : (<h4></h4>) }
      </header>
      </div>
    </>
  );
}

export default App;`,
  },
  {
    type: 'advanced',
    path: '/advance/react-node/advanced-integration/public/',
    name: 'index.html',
    content: `{FALLBACK TEMPLATE CODE}<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <link rel="icon" href="%PUBLIC_URL%/favicon.ico" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta name="theme-color" content="#000000" />
    <meta
      name="description"
      content="Web site created using create-react-app"
    />
    <!-- <link rel="apple-touch-icon" href="%PUBLIC_URL%/logo192.png" /> -->
    <!--
      manifest.json provides metadata used when your web app is installed on a
      user's mobile device or desktop. See https://developers.google.com/web/fundamentals/web-app-manifest/
    -->
    <!-- <link rel="manifest" href="%PUBLIC_URL%/manifest.json" /> -->
    <!--
      Notice the use of %PUBLIC_URL% in the tags above.
      It will be replaced with the URL of the \`public\` folder during the build.
      Only files inside the \`public\` folder can be referenced from the HTML.

      Unlike "/favicon.ico" or "favicon.ico", "%PUBLIC_URL%/favicon.ico" will
      work correctly both with client-side routing and a non-root public URL.
      Learn how to configure a non-root public URL by running \`npm run build\`.
    -->
    <title>React App</title>
  </head>
  <body>
    <script data-sdk-integration-source="integrationbuilder_ac"></script>
    <noscript>You need to enable JavaScript to run this app.</noscript>
    <div id="root"></div>
    <!--
      This HTML file is a template.
      If you open it directly in the browser, you will see an empty page.

      You can add webfonts, meta tags, or analytics to this file.
      The build step will place the bundled scripts into the <body> tag.

      To begin the development, run \`npm start\` or \`yarn start\`.
      To create a production bundle, use \`npm run build\` or \`yarn build\`.
    -->
  </body>
</html>`,
  },
  {
    type: 'advanced',
    path: '/advance/react-node/advanced-integration/src/',
    name: 'index.js',
    content: `{FALLBACK TEMPLATE CODE}import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "bootstrap/dist/css/bootstrap.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals`,
  },
  {
    type: 'advanced',
    path: '/advance/react-node/advanced-integration/src/components/',
    name: 'PaymentForm.js',
    content: `{FALLBACK TEMPLATE CODE}
import { useState, useRef, useEffect } from "react";
import styles from "./PaymentForm.module.css";
    
import {
  PayPalScriptProvider,
  PayPalHostedFieldsProvider,
  PayPalHostedField,
  PayPalButtons,
  usePayPalHostedFields,
  usePayPalScriptReducer,
} from "@paypal/react-paypal-js";
import { TailSpin } from "react-loader-spinner";
    
export const PaymentForm = (props) => {
  const [loader, showLoader] = useState(false);
  const [success, showSuccess] = useState(false);
  const [error, showErrorMsg] = useState(false);
  const [transactionData, setTransactionData] = useState();
  const [errorMsg, setErrorMsg] = useState();

  const SubmitPayment = () => {
    // Here declare the variable containing the hostedField instance
    const { cardFields } = usePayPalHostedFields();
    const cardHolderName = useRef(null);

    const submitHandler = () => {
      if (typeof cardFields.submit !== "function") return; // validate that \`submit()\` exists before using it
      if (errorMsg) showErrorMsg(false);
      showLoader(true);
      showSuccess(false);
      cardFields.submit({
        // The full name as shown in the card and billing addresss
        // These fields are optional for Sandbox but mandatory for production integration
        cardholderName: cardHolderName?.current?.value
      })
      .then((order) => {
        const { orderId } = order;

        fetch(\`/api/orders/\${orderId}/capture\`, {method: "post"})
        .then((response) => response.json())
        .then((data) => {
          showLoader(false);
          showSuccess(true);
          setTransactionData(data);
          alert("Transaction Complete. Transaction ID - "+data.id)
          // Inside the data you can find all the information related to the payment
        })
        .catch((err) => {
          // Handle capture order error
          showLoader(false);
          showErrorMsg(true);
          setErrorMsg(err);
        });
      })
      .catch((err) => {
        // Handle validate card fields error
        showLoader(false);
        showErrorMsg(true);
        setErrorMsg(err);
      });
    };

    return (
      <button
        onClick={submitHandler}
        className="btn btn-primary"
        style={{width:"720px", height:"50px", background:"#009c74", color:"white"}}
      >
        Pay
      </button>
    );
  };
  return (
    <PayPalScriptProvider
      options={{
        "client-id": props.clientID,
        "data-client-token": props.clientToken,
        components: "hosted-fields,buttons,funding-eligibility",
{{ enableFunding,react }}
        "currency": "USD",
        "buyer-country": "US",
        intent: "capture",
      }}
    >
      <div class="row" align="center" style={{marginTop:"20px", marginBottom:"20px"}}>
        <PayPalButtons style={{
          layout: "{{ buttonLayout }}", 
          shape: "{{ buttonStyle }}",
          color: (fundingSource==paypal.FUNDING.PAYLATER) ? 'gold' : '',
        }} />
      </div>
      
      <div>
        <p align="center"> OR </p>
      </div>
      
      <PayPalHostedFieldsProvider
        createOrder={() => {
          // Here define the call to create and order
          return fetch("/api/orders", {method: "post"})
            .then((response) => response.json())
            .then((order) => order.id)
            .catch((err) => {
              // Handle order creation error
              showLoader(false);
              showErrorMsg(true);
              setErrorMsg(err);
            });
        }}
      >
      
        <div id="paypal-button-container">
        </div>
        <section className={styles.container}>
          <div className={styles.card_container}>
            <PayPalHostedField
              id="card-number"
              className={styles.card_field}
              hostedFieldType="number"
              options={{
                selector: "#card-number",
                placeholder: "Card Number"
              }}
            />

            <section style={{ display: "flex" }}>
              <div style={{ flexDirection: "column" }}>
                <PayPalHostedField
                  id="expiration-date"
                  hostedFieldType="expirationDate"
                  className={styles.card_field}
                  options={{
                    selector: "#expiration-date",
                    placeholder: "Expiration Date"
                  }}
                />
              </div>
              <div style={{ flexDirection: "column", marginLeft:"80px" }}>
                <PayPalHostedField
                  id="cvv"
                  hostedFieldType="cvv"
                  options={{
                    selector: "#cvv",
                    placeholder: "CVV"
                  }}
                  className={styles.card_field}
                />
              </div>
            </section>
              
            <input
              id="card-holder"
              className={styles.card_field}
              type="text"
              placeholder="Name on Card"
            />

            <input
              id="card-billing-address-country"
              className={styles.card_field}
              type="text"
              placeholder="Country Code"
            />

            {loader && <TailSpin height="50" width="50" color="#0d6efd" />}
            {!loader && <SubmitPayment />}
          </div>
        </section>
      </PayPalHostedFieldsProvider>
    </PayPalScriptProvider>
  );
};
    `,
  },
  {
    type: 'advanced',
    path: '/advance/react-node/server/',
    name: 'paypal-api.js',
    content: `{FALLBACK TEMPLATE CODE}
import fetch from "node-fetch";
import "dotenv/config";
    
//Replace Client ID and App secret
const APP_CLIENT_ID = "{{ clientId }}";
const APP_CLIENT_SECRET = "{{ appSecret }}";
const base = "https://api-m.sandbox.paypal.com";
    
export async function createOrder() {
  const accessToken = await generateAccessToken();
  const url = \`\${base}/v2/checkout/orders\`;
  const response = await fetch(url, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: \`Bearer \${accessToken}\`,
    },
    body: JSON.stringify({
      intent: "CAPTURE",
      purchase_units: [
        {
          amount: {
            currency_code: "USD",
            value: "100.00",
          },
        },
      ],
    }),
  });
  const data = await response.json();
  return data;
}
    
export async function capturePayment(orderId) {
  const accessToken = await generateAccessToken();
  const url = \`\${base}/v2/checkout/orders/\${orderId}/capture\`;
  const response = await fetch(url, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: \`Bearer \${accessToken}\`,
    },
  });
  const data = await response.json();
  return data;
}
    
export async function generateAccessToken() {
  const auth = Buffer.from(APP_CLIENT_ID + ":" + APP_CLIENT_fSECRET).toString("base64");
  const response = await fetch(\`\${base}/v1/oauth2/token\`, {
    method: "post",
    body: "grant_type=client_credentials",
    headers: {
      Authorization: \`Basic \${auth}\`,
    },
  });
  const { access_token } = await response.json();
  return access_token;
}
    
export async function generateClientToken() {
  const accessToken = await generateAccessToken();
  const response = await fetch(\`\${base}/v1/identity/generate-token\`, {
    method: "post",
    headers: {
      Authorization: \`Bearer \${accessToken}\`,
      "Accept-Language": "en_US",
      "Content-Type": "application/json",
    },
  });
  console.log('response', response.status)
  const jsonData = await handleResponse(response);
  return jsonData.client_token;
}`,
  },
  {
    type: 'advanced',
    path: '/advance/react-java/java-server/java-main/src/main/java/com/example/controller/',
    name: 'AcdcController.java',
    content: `{FALLBACK TEMPLATE CODE}
package com.example.controller;
import org.json.JSONException;
import org.json.JSONObject;
import org.springframework.http.HttpEntity;
import org.springframework.http.HttpHeaders;
import org.springframework.http.MediaType;
import org.springframework.http.ResponseEntity;
import org.springframework.util.LinkedMultiValueMap;
import org.springframework.util.MultiValueMap;
import org.springframework.web.bind.annotation.CrossOrigin;
import org.springframework.web.bind.annotation.PathVariable;
import org.springframework.web.bind.annotation.RequestMapping;
import org.springframework.web.bind.annotation.RestController;
import org.springframework.web.client.RestTemplate;

import java.net.BindException;
import java.util.Arrays;
import java.util.Base64;

@RestController
public class AcdcController {
    String client_id = "{{ clientId }}";
    String App_secret = "{{ appSecret }}";
    @RequestMapping(value = "/")
    public String index() {
        return "/advanced-integration/public/index";
    }

    @RequestMapping("/api/token")
    public String generateClientToken() throws JSONException {
        String accessToken = "Bearer "+generateAccessToken();
        String url = "https://api-m.sandbox.paypal.com/v1/identity/generate-token";
        RestTemplate restTemplate = new RestTemplate();
        restTemplate = new RestTemplate();
        HttpHeaders headers = new HttpHeaders();
        headers.setContentType(MediaType.APPLICATION_JSON);
        headers.set("Authorization", accessToken);
        headers.set("Accept-Language", "en_US");
        String req= "{}";
        HttpEntity requestHeader = new HttpEntity(req, headers);
        ResponseEntity<String> response = restTemplate.postForEntity(url, requestHeader, String.class);
        JSONObject jsonResponse = new JSONObject(response.getBody());
        return jsonResponse.toString();
    }

    @RequestMapping("/api/orders")
    public String createOrder() throws JSONException {
        String accessToken = "Bearer " + generateAccessToken();
        RestTemplate restTemplate = new RestTemplate();
        restTemplate = new RestTemplate();
        HttpHeaders headers = new HttpHeaders();
        headers.setContentType(MediaType.APPLICATION_JSON);
        //PurchaseUnits purchaseJsonObject = new PurchaseUnits();
        headers.set("Authorization", accessToken);
        JSONObject order = new JSONObject();
        JSONObject purchaseUnits = new JSONObject();
        JSONObject amount = new JSONObject();
        amount.put("value", "100.00");
        amount.put("currency_code", "USD");
        purchaseUnits.put("amount", amount);
        order.put("purchaseunits", Arrays.asList(purchaseUnits));
        order.put("intent", "capture");

        //JsonObject purchaseJson = new JsonObject();
        String req = "{\"intent\": \"CAPTURE\",\\n" +
                "    \"purchase_units\": [\\n" +
                "        {\\n" +
                "            \"amount\": {\\n" +
                "                \"currency_code\": \"USD\",\\n" +
                "                \"value\": \"83.04\"\\n" +
                "            }\\n" +
                "        }\\n" +
                "    ]\\n" +
                "}";
        HttpEntity requestHeader = new HttpEntity(req, headers);
        String url = "https://api-m.sandbox.paypal.com/v2/checkout/orders";
        ResponseEntity<String> response = restTemplate.postForEntity(url, requestHeader, String.class);
        //System.out.println(response.toString());
        String responseString = response.toString();
        JSONObject jsonResponse = new JSONObject(response.getBody());
        String orderId = jsonResponse.getString("id");
        return jsonResponse.toString();
    }

    @RequestMapping("/api/orders/{orderId}/capture")
    public String capturePayment(@PathVariable("orderId") String orderId) throws JSONException {
      String accessToken = "Bearer " + generateAccessToken();
      return capturePayment(accessToken, String.valueOf(orderId));
    }
    
    public String capturePayment(String accessToken,String orderId) throws JSONException {
        RestTemplate restTemplate = new RestTemplate();
        restTemplate = new RestTemplate();
        HttpHeaders headers = new HttpHeaders();
        headers.setContentType(MediaType.APPLICATION_JSON);
        headers.set("Authorization", accessToken);
        String req= "{}";
        HttpEntity requestHeader = new HttpEntity(req, headers);
        String url = "https://api-m.sandbox.paypal.com/v2/checkout/orders/" + orderId + "/capture";
        ResponseEntity<String> response = restTemplate.postForEntity(url, requestHeader, String.class);
        //System.out.println(response.toString());
        String responseString = response.toString();
        JSONObject jsonResponse = new JSONObject(response.getBody());
        String orderIds = jsonResponse.getString("id");
        return jsonResponse.toString();
    }

    public String generateAccessToken() throws JSONException {
        String clientIdSecret = client_id + ":" + App_secret;
        String encodedClientId = Base64.getEncoder().encodeToString(clientIdSecret.getBytes());
        System.out.println("Client Id= " + encodedClientId);
        String template = "Basic " + encodedClientId;
        RestTemplate restTemplate = new RestTemplate();
        restTemplate = new RestTemplate();
        HttpHeaders headers = new HttpHeaders();
        headers.setContentType(MediaType.APPLICATION_FORM_URLENCODED);
        headers.set("Authorization", template);
        MultiValueMap<String, String> map = new LinkedMultiValueMap<>();
        map.add("grant_type","client_credentials");
        map.add("response_type","token");
        map.add("ignoreCache","true");
        HttpEntity requestHeader = new HttpEntity( map,headers);
        String url = "https://api-m.sandbox.paypal.com/v1/oauth2/token";
        ResponseEntity<String> response = restTemplate.postForEntity(url, requestHeader, String.class);
        //System.out.println(response.toString());
        JSONObject jsonResponse = new JSONObject(response.getBody());
        String accessToken = jsonResponse.getString("access_token");
        return accessToken;
    }

}`,
  },
  {
    type: 'advanced',
    path: '/advance/html-java/',
    name: 'index.java',
    content: `{FALLBACK TEMPLATE CODE}package com.example;

import org.json.JSONException;
import org.json.JSONObject;
import org.springframework.http.HttpEntity;
import org.springframework.http.HttpHeaders;
import org.springframework.http.MediaType;
import org.springframework.http.ResponseEntity;
import org.springframework.util.LinkedMultiValueMap;
import org.springframework.util.MultiValueMap;
import org.springframework.web.bind.annotation.PathVariable;
import org.springframework.web.bind.annotation.RequestBody;
import org.springframework.web.bind.annotation.RequestMapping;
import org.springframework.web.bind.annotation.RestController;
import org.springframework.web.client.RestTemplate;

import java.util.Arrays;
import java.util.Base64;

@RestController
public class Index {
    String client_id = "{{ clientId }}";
    String App_secret = "{{ appSecret }}";

    @RequestMapping("/api/orders")
    public String createOrder() throws JSONException {
        String accessToken = "Bearer " + generateAccessToken();
        RestTemplate restTemplate = new RestTemplate();
        restTemplate = new RestTemplate();
        HttpHeaders headers = new HttpHeaders();
        headers.setContentType(MediaType.APPLICATION_JSON);
        //PurchaseUnits purchaseJsonObject = new PurchaseUnits();
        headers.set("Authorization", accessToken);
        JSONObject order = new JSONObject();
        JSONObject purchaseUnits = new JSONObject();
        JSONObject amount = new JSONObject();
        amount.put("value", "100.00");
        amount.put("currency_code", "USD");
        purchaseUnits.put("amount", amount);
        order.put("purchaseunits", Arrays.asList(purchaseUnits));
        order.put("intent", "capture");

        //JsonObject purchaseJson = new JsonObject();
        String req = "{\\"intent\\": \\"CAPTURE\\",\\n" +
                "    \\"purchase_units\\": [\\n" +
                "        {\\n" +
                "            \\"amount\\": {\\n" +
                "                \\"currency_code\\": \\"USD\\",\\n" +
                "                \\"value\\": \\"83.04\\"\\n" +
                "            }\\n" +
                "        }\\n" +
                "    ]\\n" +
                "}";


        HttpEntity requestHeader = new HttpEntity(req, headers);
        String url = "https://api-m.sandbox.paypal.com/v2/checkout/orders";
        ResponseEntity<String> response = restTemplate.postForEntity(url, requestHeader, String.class);
        //System.out.println(response.toString());
        String responseString = response.toString();
        JSONObject jsonResponse = new JSONObject(response.getBody());
        String orderId = jsonResponse.getString("id");
        return jsonResponse.toString();
    }

    @RequestMapping("/api/orders/{orderId}/capture")
    public String capturePayment(@PathVariable("orderId") String orderId) throws JSONException {
        String accessToken = "Bearer " + generateAccessToken();
        return capturePayment(accessToken, String.valueOf(orderId));

    }

        public String capturePayment(String accessToken,String orderId) throws JSONException {
        RestTemplate restTemplate = new RestTemplate();
        restTemplate = new RestTemplate();
        HttpHeaders headers = new HttpHeaders();
        headers.setContentType(MediaType.APPLICATION_JSON);
        headers.set("Authorization", accessToken);
        String req= "{}";
        HttpEntity requestHeader = new HttpEntity(req, headers);
        String url = "https://api-m.sandbox.paypal.com/v2/checkout/orders/" + orderId + "/capture";
        ResponseEntity<String> response = restTemplate.postForEntity(url, requestHeader, String.class);
        //System.out.println(response.toString());
        String responseString = response.toString();
        JSONObject jsonResponse = new JSONObject(response.getBody());
        String orderIds = jsonResponse.getString("id");
        return jsonResponse.toString();
    }

    public String generateAccessToken() throws JSONException {
        String clientIdSecret = client_id + ":" + App_secret;
        String encodedClientId = Base64.getEncoder().encodeToString(clientIdSecret.getBytes());
        System.out.println("Client Id= " + encodedClientId);
        String template = "Basic " + encodedClientId;
        RestTemplate restTemplate = new RestTemplate();
        restTemplate = new RestTemplate();
        HttpHeaders headers = new HttpHeaders();
        headers.setContentType(MediaType.APPLICATION_FORM_URLENCODED);
        headers.set("Authorization", template);
        MultiValueMap<String, String> map = new LinkedMultiValueMap<>();
        map.add("grant_type","client_credentials");
        map.add("response_type","token");
        map.add("ignoreCache","true");
        HttpEntity requestHeader = new HttpEntity( map,headers);
        String url = "https://api-m.sandbox.paypal.com/v1/oauth2/token";
        ResponseEntity<String> response = restTemplate.postForEntity(url, requestHeader, String.class);
        //System.out.println(response.toString());
        JSONObject jsonResponse = new JSONObject(response.getBody());
        String accessToken = jsonResponse.getString("access_token");
        return accessToken;
    }

    @RequestMapping("/api/token")
    public String generateClientToken() throws JSONException {
        String accessToken = "Bearer "+generateAccessToken();
        String url = "https://api-m.sandbox.paypal.com/v1/identity/generate-token";
        RestTemplate restTemplate = new RestTemplate();
        restTemplate = new RestTemplate();
        HttpHeaders headers = new HttpHeaders();
        headers.setContentType(MediaType.APPLICATION_JSON);
        headers.set("Authorization", accessToken);
        headers.set("Accept-Language", "en_US");
        String req= "{}";
        HttpEntity requestHeader = new HttpEntity(req, headers);
        ResponseEntity<String> response = restTemplate.postForEntity(url, requestHeader, String.class);
        JSONObject jsonResponse = new JSONObject(response.getBody());
        return jsonResponse.toString();
    }

}`,
  },
  {
    type: 'advanced',
    path: '/advance/react-java/java-server/java-main/src/main/java/com/example/',
    name: 'WebApplication.java',
    content: `{FALLBACK TEMPLATE CODE}
package com.example;
import org.springframework.boot.SpringApplication;
import org.springframework.boot.autoconfigure.SpringBootApplication;


@SpringBootApplication
public class WebApplication {
  public static void main(String[] args) {
    SpringApplication.run(WebApplication.class, args);
    System.out.println("#@# started");
  }
}`,
  },
  {
    type: 'advanced',
    path: '/advance/html-node/',
    name: 'index.js',
    content: `{FALLBACK TEMPLATE CODE}
import fetch from "node-fetch";

const CLIENT_ID = '{{ clientId }}';
const APP_SECRET = '{{ appSecret }}';
const base = "https://api-m.sandbox.paypal.com";

// call the create order method
export async function createOrder() {
  const purchaseAmount = "100.00";
  const accessToken = await generateAccessToken();
  const url = \`\${base}/v2/checkout/orders\`;
  const response = await fetch(url, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: \`Bearer \${accessToken}\`,
    },
    body: JSON.stringify({
      intent: "CAPTURE",
      purchase_units: [
        {
          amount: {
            currency_code: "USD",
            value: purchaseAmount,
          },
        },
      ],
    }),
  });

  return handleResponse(response);
}

// capture payment for an order
export async function capturePayment(orderId) {
  const accessToken = await generateAccessToken();
  const url = \`\${base}/v2/checkout/orders/\${orderId}/capture\`;
  const response = await fetch(url, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: \`Bearer \${accessToken}\`,
    },
  });

  return handleResponse(response);
}

// generate access token
export async function generateAccessToken() {
  const auth = Buffer.from(CLIENT_ID + ":" + APP_SECRET).toString("base64");
  const response = await fetch(\`\${base}/v1/oauth2/token\`, {
    method: "post",
    body: "grant_type=client_credentials",
    headers: {
      Authorization: \`Basic \${auth}\`,
    },
  });
  const jsonData = await handleResponse(response);
  return jsonData.access_token;
}

// generate client token
export async function generateClientToken() {
  const accessToken = await generateAccessToken();
  const response = await fetch(\`\${base}/v1/identity/generate-token\`, {
    method: "post",
    headers: {
      Authorization: \`Bearer \${accessToken}\`,
      "Accept-Language": "en_US",
      "Content-Type": "application/json",
    },
  });
  console.log('response', response.status)
  const jsonData = await handleResponse(response);
  return jsonData.client_token;
}

async function handleResponse(response) {
  if (response.status === 200 || response.status === 201) {
    return response.json();
  }

  const errorMessage = await response.text();
  throw new Error(errorMessage);
}`,
  },
  {
    type: 'advanced',
    path: '/advance/html-node/',
    name: 'server.js',
    content: `{FALLBACK TEMPLATE CODE}
import "dotenv/config";
import express from "express";
import * as paypal from "./paypal-api.js";

const app = express();
app.set("view engine", "ejs");
app.use(express.static("public"));

// render checkout page with client id & unique client token
app.get("/", async (req, res) => {
  const clientId = process.env.CLIENT_ID;
  try {
    const clientToken = await paypal.generateClientToken();
    res.render("checkout", { clientId, clientToken });
  } catch (err) {
    res.status(500).send(err.message);
  }
});

// create order
app.post("/api/orders", async (req, res) => {
  try {
    const order = await paypal.createOrder();
    res.json(order);
  } catch (err) {
    res.status(500).send(err.message);
  }
});

// capture payment
app.post("/api/orders/:orderID/capture", async (req, res) => {
  const { orderID } = req.params;
  try {
    const captureData = await paypal.capturePayment(orderID);
    res.json(captureData);
  } catch (err) {
    res.status(500).send(err.message);
  }
});

app.listen(9597, () => {
  console.log("listening on http://localhost:9597/");
});
    `,
  },
  {
    type: 'standard',
    path: '/standard/html-python/',
    name: 'server.py',
    content: `{FALLBACK TEMPLATE CODE}from flask import Flask, send_file
    import requests
    import json
    app = Flask(__name__)
    
    # https://developer.paypal.com/api/rest/authentication/
    def get_access_token():
        client_id = '{{ clientId }}'
        app_secret = '{{ appSecret }}'
        url = "https://api-m.sandbox.paypal.com/v1/oauth2/token"
        response = requests.post(url, data={"grant_type": "client_credentials"}, auth=(client_id,app_secret))
        data = response.json()
        if data.get('error'):
            raise Exception(data)
        return data['access_token']
    
    # https://developer.paypal.com/docs/api/orders/v2/#orders_create
    def create_order():
        url = "https://api-m.sandbox.paypal.com/v2/checkout/orders"
        payload = {
            'intent': 'CAPTURE',
            'purchase_units': [{
                "amount": {
                    "currency_code": "USD",
                    "value": "0.02"
                }
            }]
        }
        headers = {
            'Authorization': f"Bearer {get_access_token()}",
            'Content-Type': 'application/json'
        }
        response = requests.post(url, headers = headers, data = json.dumps(payload))
        data = response.json()
        if data.get('error'):
            raise Exception(data)
        return data
    
    # https://developer.paypal.com/docs/api/orders/v2/#orders_capture
    def capture_payment(order_id):
        url = f"https://api-m.sandbox.paypal.com/v2/checkout/orders/{order_id}/capture"
        headers = {
            'Authorization': f"Bearer {get_access_token()}",
            'Content-Type': 'application/json'
        }
        response = requests.post(url, headers = headers)
        data = response.json()
        if data.get('error'):
            raise Exception(data)
        return data
    
    @app.route('/')
    def index():
        return send_file("./index.html")
    
    @app.route('/orders', methods = ['POST'])
    def process_create_order():
        return create_order()
    
    @app.route('/orders/<order_id>/capture', methods = ['POST'])
    def process_capture_payment(order_id): 
        return capture_payment(order_id)
    
    if __name__ == '__main__':
       app.run()`,
  },
  {
    type: 'standard',
    path: '/standard/html-php/',
    name: 'server.php',
    content: `{FALLBACK TEMPLATE CODE}<?php
    // https://developer.paypal.com/api/rest/authentication/
    function get_access_token(){
        $client_id = '{{ clientId }}';
        $app_secret = '{{ appSecret }}';
        $url = "https://api-m.sandbox.paypal.com/v1/oauth2/token";
        $data = http_build_query([
            'grant_type' => 'client_credentials',
        ]);
        $ch = curl_init();
        curl_setopt($ch, CURLOPT_URL, $url);
        curl_setopt($ch, CURLOPT_USERPWD, $client_id . ":" . $app_secret);
        curl_setopt($ch, CURLOPT_POST, true);
        curl_setopt($ch, CURLOPT_POSTFIELDS, $data);
        curl_setopt($ch, CURLOPT_RETURNTRANSFER, true); 
        $result = json_decode(curl_exec($ch));
        if(isset($result->error)){
            throw new Exception($result->error_description);
        }
        return $result->access_token;
    }

    // https://developer.paypal.com/docs/api/orders/v2/#orders_create
    function create_order(){
        $url = "https://api-m.sandbox.paypal.com/v2/checkout/orders";
        $data = json_encode([
            'intent' => 'CAPTURE',
            'purchase_units' => [
                [
                    "amount" => [
                        "currency_code" => "USD",
                        "value" => "0.02"
                    ]
                ]
            ]
        ]);
        $ch = curl_init();
        curl_setopt($ch, CURLOPT_URL, $url);
        curl_setopt($ch, CURLOPT_POST, true);
        curl_setopt($ch, CURLOPT_POSTFIELDS, $data);
        curl_setopt($ch, CURLOPT_HTTPHEADER, [
            'Content-Type:application/json',
            'Authorization: Bearer ' . get_access_token()
        ]);
        curl_setopt($ch, CURLOPT_RETURNTRANSFER, true); 
        $result = json_decode(curl_exec($ch));
        if(isset($result->error)){
            throw new Exception($result->error_description);
        }
        return $result;
    }

    // https://developer.paypal.com/docs/api/orders/v2/#orders_capture
    function capture_payment($orderID){
        $url = "https://api-m.sandbox.paypal.com/v2/checkout/orders/" . $orderID . "/capture";
        $ch = curl_init();
        curl_setopt($ch, CURLOPT_URL, $url);
        curl_setopt($ch, CURLOPT_POST, true);
        curl_setopt($ch, CURLOPT_HTTPHEADER, [
            'Content-Type:application/json',
            'Authorization: Bearer ' . get_access_token()
        ]);
        curl_setopt($ch, CURLOPT_RETURNTRANSFER, true); 
        $result = json_decode(curl_exec($ch));
        if(isset($result->error)){
            throw new Exception($result->error_description);
        }
        return $result;
    }

    $json = json_decode(file_get_contents('php://input'));
    if(isset($json->orderID)){
        // capture the order
        echo json_encode(capture_payment($json->orderID));
        // echo json_encode();
    } else {
        // create the order
        echo json_encode(create_order());
    }
?>`,
  },
  {
    type: 'advanced',
    path: '/advance/html-python/',
    name: 'index.py',
    content: `{FALLBACK TEMPLATE CODE}import http.server
    # from aioflask import Flask, request, jsonify, after_this_request, send_file, render_template
    from flask import Flask, request, jsonify, after_this_request, send_file, render_template
    import socketserver
    import requests
    import base64
    
    PORT = 8000
    app = Flask(__name__)
    base = "https://api-m.sandbox.paypal.com"
    
    CLIENT_ID = '{{ clientId }}'
    APP_SECRET = '{{ appSecret }}'
    
    
    @app.route('/')
    async def index():
        token = await generateClientToken()
        return render_template("index.html", token=token)
    
    
    @app.route('/api/orders', methods=['POST'])
    async def createOrder():
        purchase_amount = "100.00"
        access_token = await generateAccessToken()
        # access_token = "Bearer {{ appSecret }}"
        URL = base+"/v2/checkout/orders"
        headers = {"Content-Type": "application/json",  "Authorization": "Bearer "+access_token}
        data = {"intent": "CAPTURE", "purchase_units": [{"amount": {"currency_code": "USD", "value": purchase_amount}}]}
        response = requests.post(url=URL, headers=headers, json=data)
        resp = await handleResponse(response)
        return resp
    
    
    @app.route('/api/orders/<orderID>/capture', methods=['POST'])
    async def captureOrder(orderID):
        # access_token = "{{ appSecret }}"
        access_token = await generateAccessToken()
        URL = base+"/v2/checkout/orders/"+orderID+"/capture"
        headers = {"Content-Type": "application/json", "Authorization": "Bearer "+access_token}
        response = requests.post(url=URL, headers=headers)
        resp = await handleResponse(response)
        return resp
    
    
    async def generateClientToken():
        access_token = await generateAccessToken()
        URL = base+"/v1/identity/generate-token"
        headers = {"Authorization": "Bearer "+access_token, "Accept-Language": "en_US", "Content-Type": "application/json"}
        response = requests.post(url=URL, headers=headers)
        data = response.json()
        if data.get('error'):
            raise Exception(data)
        return data['client_token']
    
    
    async def generateAccessToken():
        url = "https://api-m.sandbox.paypal.com/v1/oauth2/token"
        response = requests.post(url, data={"grant_type": "client_credentials"}, auth=(CLIENT_ID, APP_SECRET))
        data = response.json()
        if data.get('error'):
            raise Exception(data)
        return data['access_token']
    
    
    async def handleResponse(response):
        if response.status_code == 200 or response.status_code == 201:
            return response.json()
        error_message = response.text
        raise Exception(error_message)
    
    
    app.run(host='localhost', port=8000)`,
  },
  {
    type: 'advanced',
    path: '/advance/angular-python/',
    name: 'server.py',
    content: `{FALLBACK TEMPLATE CODE}import http.server
    # from aioflask import Flask, request, jsonify, send_file
    from flask import Flask, request, jsonify, after_this_request, send_file
    import socketserver
    import requests
    import base64
    
    PORT = 8000
    app = Flask(__name__)
    base = "https://api-m.sandbox.paypal.com"
    
    CLIENT_ID = '{{ clientId }}'
    APP_SECRET = '{{ appSecret }}'
    
    
    @app.route('/')
    def index():
        return send_file("templates/index.html")
    
    
    @app.route('/api/orders', methods=['POST'])
    async def createOrder():
        purchase_amount = "100.00"
        access_token = await generateAccessToken()
        # access_token = "Bearer {{ appSecret }}"
        URL = base+"/v2/checkout/orders"
        headers = {"Content-Type": "application/json",  "Authorization": "Bearer "+access_token}
        data = {"intent": "CAPTURE", "purchase_units": [{"amount": {"currency_code": "USD", "value": purchase_amount}}]}
        response = requests.post(url=URL, headers=headers, json=data)
        print(response)
        resp = await handleResponse(response)
        print(resp)
        return resp
    
    
    @app.route('/api/orders/<orderID>/capture', methods=['POST'])
    async def captureOrder(orderID):
        # access_token = "{{ appSecret }}"
        access_token = await generateAccessToken()
        URL = base+"/v2/checkout/orders/"+orderID+"/capture"
        headers = {"Content-Type": "application/json", "Authorization": "Bearer "+access_token}
        response = requests.post(url=URL, headers=headers)
        resp = await handleResponse(response)
        return resp
    
    @app.route('/api/token', methods=['POST'])
    async def generateClientToken():
        access_token = await generateAccessToken()
        URL = "https://api-m.sandbox.paypal.com/v1/identity/generate-token"
        headers = {"Authorization": "Bearer "+access_token, "Accept-Language": "en_US", "Content-Type": "application/json"}
        response = requests.post(url=URL, headers=headers)
        json_data = await handleResponse(response)
        return json_data
    
    
    async def generateAccessToken():
        url = "https://api-m.sandbox.paypal.com/v1/oauth2/token"
        response = requests.post(url, data={"grant_type": "client_credentials"}, auth=(CLIENT_ID, APP_SECRET))
        data = response.json()
        if data.get('error'):
            raise Exception(data)
        return data['access_token']
    
    
    async def handleResponse(response):
        print(response.status_code)
        if response.status_code == 200 or response.status_code == 201:
            return response.json()
        error_message = response.text
        raise Exception(error_message)
    
    
    app.run(host='localhost', port=8000)`,
  },
  {
    type: 'advanced',
    path: '/advance/html-php/',
    name: 'index.php',
    content: `{FALLBACK TEMPLATE CODE}<?php
    // https://developer.paypal.com/api/rest/authentication/
    function get_access_token(){
        $client_id = '{{ clientId }}';
        $app_secret = '{{ appSecret }}';
        $url = "https://api-m.sandbox.paypal.com/v1/oauth2/token";
        $data = http_build_query([
            'grant_type' => 'client_credentials',
        ]);
        $ch = curl_init();
        curl_setopt($ch, CURLOPT_URL, $url);
        curl_setopt($ch, CURLOPT_USERPWD, $client_id . ":" . $app_secret);
        curl_setopt($ch, CURLOPT_POST, true);
        curl_setopt($ch, CURLOPT_POSTFIELDS, $data);
        curl_setopt($ch, CURLOPT_RETURNTRANSFER, true); 
        $result = json_decode(curl_exec($ch));
        if(isset($result->error)){
            throw new Exception($result->error_description);
        }
        return $result->access_token;
    }

    // https://developer.paypal.com/docs/api/orders/v2/#orders_create
    function create_order(){
        $url = "https://api-m.sandbox.paypal.com/v2/checkout/orders";
        $data = json_encode([
            'intent' => 'CAPTURE',
            'purchase_units' => [
                [
                    "amount" => [
                        "currency_code" => "USD",
                        "value" => "0.02"
                    ]
                ]
            ]
        ]);
        $ch = curl_init();
        curl_setopt($ch, CURLOPT_URL, $url);
        curl_setopt($ch, CURLOPT_POST, true);
        curl_setopt($ch, CURLOPT_POSTFIELDS, $data);
        curl_setopt($ch, CURLOPT_HTTPHEADER, [
            'Content-Type:application/json',
            'Authorization: Bearer {{ appSecret }}' 
        ]);
        curl_setopt($ch, CURLOPT_RETURNTRANSFER, true); 
        $result = json_decode(curl_exec($ch));
        if(isset($result->error)){
            throw new Exception($result->error_description);
        }
        return $result;
    }

    // https://developer.paypal.com/docs/api/orders/v2/#orders_capture
    function capture_payment($orderID){
        $url = "https://api-m.sandbox.paypal.com/v2/checkout/orders/" . $orderID . "/capture";
        $ch = curl_init();
        curl_setopt($ch, CURLOPT_URL, $url);
        curl_setopt($ch, CURLOPT_POST, true);
        curl_setopt($ch, CURLOPT_HTTPHEADER, [
            'Content-Type:application/json',
            'Authorization: Bearer ' . get_access_token()
        ]);
        curl_setopt($ch, CURLOPT_RETURNTRANSFER, true); 
        $result = json_decode(curl_exec($ch));
        if(isset($result->error)){
            throw new Exception($result->error_description);
        }
        return $result;
    }

    $json = json_decode(file_get_contents('php://input'));
    if(isset($json->orderID)){
        // capture the order
        echo json_encode(capture_payment($json->orderID));
        // echo json_encode();
    } else {
        // create the order
        echo json_encode(create_order());
    }
?>`,
  },
  // {
  //   type: 'advanced',
  //   path: '/advance/html-node/public/',
  //   name: 'index.html',
  //   content: `{FALLBACK TEMPLATE CODE}`,
  // },
]
